import React, { useEffect } from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  bool, func, oneOf, string,
} from 'prop-types'

import { MODERATION_ACTION } from 'Pods/LazyLoaded/ImageGalleryPanel/Components/Gallery/Hooks/useImageModeration'
import Modal from 'Pods/Shared/Modal/Modal'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

function ModerationConfirmModal({
  action,
  title = '',
  isSubmitDisabled = false,
  onConfirm: handleConfirm,
  onCancel: handleCancel,
}) {
  const t = useTranslation()
  const header = t(`imageGallery.moderation.${action}.header`)

  // Enter confirms from anywhere in the dialog. A focused control (Cancel, the close
  // button) already acts on Enter natively, so the key is left to it there to avoid
  // firing both.
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key !== 'Enter' || event.repeat || event.target.closest('button, a, input, textarea, select')) return

      event.preventDefault()
      if (!isSubmitDisabled) handleConfirm()
    }

    document.addEventListener('keydown', handleKeyDown)
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [handleConfirm, isSubmitDisabled])


  const footer = (
    <>
      <Button type="secondary" size="small" actionType="button" onClick={handleCancel}>
        {t('imageGallery.moderation.cancel')}
      </Button>
      <Button
        type={action === MODERATION_ACTION.DELETE ? 'primary-warning' : 'primary'}
        size="small"
        actionType="button"
        disabled={isSubmitDisabled}
        onClick={handleConfirm}
      >
        {t(`imageGallery.moderation.${action}.confirm`)}
      </Button>
    </>
  )

  return (
    <Modal
      header={header}
      ariaLabel={header}
      width="small"
      footer={footer}
      customClass="moderation-confirm-modal"
      onClose={handleCancel}
    >
      <span className="cgt-body-md">
        {t(`imageGallery.moderation.${action}.body`, { title })}
      </span>
    </Modal>
  )
}

ModerationConfirmModal.propTypes = {
  action: oneOf(Object.values(MODERATION_ACTION)).isRequired,
  title: string,
  isSubmitDisabled: bool,
  onConfirm: func.isRequired,
  onCancel: func.isRequired,
}

export default ModerationConfirmModal
